import { createApp } from 'vue'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'
import filters from "./utils/filters"
import router from './router/index'
import App from './App.vue'
const app = createApp(App)
app.use(ElementPlus).use(router).mount('#app')
app.config.globalProperties.$filters = filters;